import Sidebar from './Sidebar';
import '../Sidebar.css';


const Admin_Dashboard = () => (
  <div style={{ display: 'flex' }}>
    <Sidebar />
    <div style={{ marginLeft: '220px', padding: '20px' }}>
      <h1>Welcome to the Dashboard</h1>
    </div>
  </div>
);

export default Admin_Dashboard;
